import {RudderAnalytics} from '@rudderstack/analytics-js';
import type {AnalyticsInstance, AnalyticsPlugin} from 'analytics';
import Analytics from 'analytics';

interface RudderstackConfig {
  writeKey: string;
  dataPlaneUrl: string;
}

export interface EzcaterAnalyticsConfig {
  rudderstack: RudderstackConfig;
}

function rudderstackEvents(config: RudderstackConfig): AnalyticsPlugin {
  let rudderInstance: InstanceType<typeof RudderAnalytics>;

  return {
    name: 'rudderstackEvents',
    initialize: () => {
      // RudderStack is a browser-only SDK — skip initialization in SSR environments.
      if (typeof window === 'undefined') return;
      rudderInstance = new RudderAnalytics();
      rudderInstance.load(config.writeKey, config.dataPlaneUrl);
    },
    page: () => {
      rudderInstance?.page();
    },
  } as AnalyticsPlugin;
}

export function createEzcaterAnalytics(config: EzcaterAnalyticsConfig): AnalyticsInstance {
  const plugins: AnalyticsPlugin[] = [rudderstackEvents(config.rudderstack)];
  return Analytics({app: 'ezcater', plugins});
}
